import React, { useState, useEffect, useContext } from 'react';
import axios from '../../../axios'; // Adjust the import based on your file structure
import Select, { components } from 'react-select';
import AuthContext from '../../../AuthContext';
import PropTypes from 'prop-types';

// Custom menu component without infinite scrolling
const CustomMenuList = (props) => {
  const { children } = props;

  return (
    <components.MenuList {...props} className="custom-menu-list">
      {children} {/* Render all children */}
    </components.MenuList>
  );
};

// Component to handle multi-select course dropdown
const MultiSelectCourseDropdown = ({ selectedCourses = [], onChange }) => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const { centre } = useContext(AuthContext);
  console.log(selectedCourses);

  // Fetch courses from the API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get('/trainingcentre/getIdName');
        console.log(response.data);
        setCourses(response.data.centres);
      } catch (error) {
        setError('Error fetching sectors.');
      }
    };

    fetchCourses();
  }, [centre]);

  // Transform course data for react-select
  const options = courses.map(course => ({
    value: course.centre_id,
    label: course.centre_name,
  }));

  // Handle change event from react-select
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    onChange(selectedValues);
  };

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Center Name
      </label>
      <Select
        isMulti
        options={options}
        value={options.filter(option => selectedCourses && selectedCourses.includes(option.value))}
        onChange={handleChange}
        className={`basic-single ${error ? 'border-red-600' : ''}`}
        classNamePrefix="Select"
        components={{ MenuList: CustomMenuList }}
        placeholder="Select centers..."
      />
      {error && <p className="text-red-500">{error}</p>}
      <style jsx>{`
        /* Style the dropdown control to match the Financial Year dropdown */
        .Select__control {
          border: 1px solid #e5e7eb; /* Lighter gray border */
          border-radius: 6px; /* Slightly more rounded corners */
          box-shadow: 0 1px 1px rgba(0, 0, 0, 0.03); /* More subtle shadow */
          background-color: white; /* White background */
          min-height: 40px; /* Slightly taller to match */
          font-size: 14px; /* Match font size */
          color: #1f2937; /* Dark text color */
          padding: 2px 4px; /* Adjusted padding */
          transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }

        /* Hover state */
        .Select__control:hover {
          border-color: #d1d5db; /* Slightly darker border on hover */
        }

        /* Focused state */
        .Select__control--is-focused {
          border-color: #d1d5db; /* Slightly darker border when focused */
          box-shadow: 0 0 0 1px #d1d5db; /* Subtle focus ring */
          outline: none;
        }

        /* Style the placeholder */
        .Select__placeholder {
          color: #9ca3af; /* Lighter gray for placeholder */
          font-size: 14px;
        }

        /* Style the dropdown menu */
        .custom-menu-list {
          max-height: 150px;
          overflow-y: auto; /* Show scrollbar when needed */
          border: 1px solid #e5e7eb; /* Lighter gray border */
          border-radius: 6px; /* Rounded corners */
          padding: 2px;
          background-color: white; /* White background */
        }

        /* Style the dropdown options */
        .Select__option {
          font-size: 14px;
          color: #1f2937; /* Dark text color */
          background-color: white;
          padding: 6px 8px; /* Adjusted padding for options */
        }

        /* Hover state for options */
        .Select__option--is-focused {
          background-color: #f9fafb; /* Very light gray background on hover */
          color: #1f2937;
        }

        /* Selected state for options */
        .Select__option--is-selected {
          background-color: #f3f4f6; /* Lighter gray for selected */
          color: #1f2937;
        }

        /* Style the dropdown arrow */
        .Select__dropdown-indicator {
          color: #9ca3af; /* Lighter gray arrow */
          padding: 4px; /* Smaller padding to make arrow area smaller */
        }

        /* Style the multi-value (selected items) */
        .Select__multi-value {
          background-color: #f3f4f6; /* Lighter gray background for selected items */
          border-radius: 4px;
          margin: 2px; /* Smaller margin to match compact look */
        }

        /* Style the multi-value label */
        .Select__multi-value__label {
          color: #1f2937; /* Dark text color */
          font-size: 13px; /* Slightly smaller font */
          padding: 2px 4px; /* Compact padding */
        }

        /* Style the multi-value remove button */
        .Select__multi-value__remove {
          color: #9ca3af; /* Lighter gray 'x' */
          padding: 2px;
        }

        .Select__multi-value__remove:hover {
          background-color: #e5e7eb; /* Slightly darker on hover */
          color: #6b7280; /* Darker 'x' on hover */
        }
      `}</style>
    </div>
  );
};

// PropTypes for type validation
MultiSelectCourseDropdown.propTypes = {
  selectedCourses: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default MultiSelectCourseDropdown;